import { deleteContact } from "../../../cleuracloud/monitoring/contacts/actions";
import { deleteSchedule } from "../../../cleuracloud/monitoring/schedules/actions";
import {
  deleteCleuraUser,
  deleteMultipleCleuraUsers,
} from "../../../cleuracloud/users/actions";
import {
  deleteMultipleShoots,
  deleteShoot,
  deleteWorker,
  hibernateMultipleShoots,
  hibernateShoot,
  maintainMultipleShoots,
  maintainShoot,
  reconcileMultipleShoots,
  reconcileShoot,
  retryMultipleShoots,
  rotatekubeconfigShoot,
  wakeupMultipleShoots,
  wakeupShoot,
} from "../../../gardener/reducer/actions";
import {
  deleteMultipleProvisionedApps,
  deleteProvisionedApp,
} from "../../../marketplace/provisioned/reducer/actions";
import {
  deleteMultipleVolumes,
  deleteVolume,
  detachMultipleVolumes,
  detachVolume,
  disableDisasterRecoveryMultipleVolumes,
  disableDisasterRecoveryVolume,
  enableDisasterRecoveryMultipleVolumes,
  enableDisasterRecoveryVolume,
  restoresnapshotVolume,
} from "../../../openstack/cinder/volumes/actions";
import {
  deleteMultipleVolume_snapshots,
  deleteVolume_snapshot,
} from "../../../openstack/cinder/volumes/snapshots/actions";
import {
  acceptImage,
  addImageMember,
  deleteImageMember,
  deletePrivateImage,
  rejectImage,
} from "../../../openstack/images/privateImages/redux/actions";
import { deleteCluster } from "../../../openstack/magnum/clusters/actions";
import { deleteClustertemplate } from "../../../openstack/magnum/clustertemplate/actions";
import {
  deleteEndpointgroup,
  deleteMultipleEndpointgroups,
} from "../../../openstack/neutron/endpointgroups/actions";
import {
  deleteFloatingip,
  deleteMultipleFloatingips,
  disconnectFloatingip,
} from "../../../openstack/neutron/floatingips/actions";
import {
  deleteIke,
  deleteMultipleIkes,
} from "../../../openstack/neutron/ike/reducer/actions";
import {
  deleteIpsec,
  deleteMultipleIpsecs,
} from "../../../openstack/neutron/ipsec/reducer/actions";
import {
  deleteLoadbalancer,
  deleteMultipleLoadbalancers,
} from "../../../openstack/neutron/lbaas/actions";
import { deleteHealthmonitor } from "../../../openstack/neutron/lbaas/healthmonitors/actions";
import { deleteListener } from "../../../openstack/neutron/lbaas/listeners/actions";
import { deletePool } from "../../../openstack/neutron/lbaas/pools/actions";
import { deleteNetwork } from "../../../openstack/neutron/networks/actions";
import {
  deleteMultiplePorts,
  deletePort,
} from "../../../openstack/neutron/ports/actions";
import {
  deleteRouter,
  removeinterfaceRouter,
} from "../../../openstack/neutron/routers/actions";
import { deleteSubnet } from "../../../openstack/neutron/subnets/actions";
import {
  deleteIpsec_site_connection,
  deleteMultipleVpns,
  deleteVpn,
  resetMultipleVPNs,
} from "../../../openstack/neutron/vpn/actions";
import {
  deleteMultipleOrchestration_stacks,
  deleteOrchestration_stack,
  resumeMultipleOrchestration_stacks,
  suspendMultipleOrchestration_stacks,
  suspendOrchestration_stack,
} from "../../../openstack/orchestration/actions";
import {
  deleteStack_snapshot,
  restoreStack_snapshot,
} from "../../../openstack/orchestration/detailedview/snapshots/actions";
import {
  deleteMultipleRules,
  deleteMultipleSecurityGroups,
  deleteRule,
  deleteSecuritygroup,
} from "../../../openstack/securitygroups/actions";
import {
  deleteMultipleServers,
  deleteServer,
  pauseMultipleServers,
  pauseServer,
  rebootMultipleServers,
  rebootServer,
  removeSecurityGroupFromServer,
  resizeCancel,
  restoresnapshotServer,
  stopMultipleServers,
  disconnectFloatingIP as disconnectServerFloatingIP,
  stopServer,
} from "../../../openstack/servers/actions";
import {
  deleteKeypair,
  deleteMultipleKeypairs,
} from "../../../openstack/servers/keypairs/actions";
import {
  deleteMultipleServer_snapshots,
  deleteServer_snapshot,
} from "../../../openstack/servers/snapshots/actions";
import {
  deleteMultipleOpenstack_users,
  deleteOpenstack_user,
} from "../../../openstack/users/actions";
import { deleteEmail } from "../../accountsettings/contact/emails/actions";
import { deletePhone } from "../../accountsettings/contact/phone/actions";

export const actionMap: Record<string, any> = {
  "cleura user": {
    multiple: {
      delete: deleteMultipleCleuraUsers,
    },
    single: {
      delete: deleteCleuraUser,
    },
  },
  "cluster template": {
    single: {
      delete: deleteClustertemplate,
    },
  },
  contact: {
    single: {
      delete: deleteContact,
    },
  },
  email: {
    single: {
      delete: deleteEmail,
    },
  },
  "endpoint group": {
    multiple: {
      delete: deleteMultipleEndpointgroups,
    },
    single: {
      delete: deleteEndpointgroup,
    },
  },
  "floating ip": {
    multiple: {
      delete: deleteMultipleFloatingips,
    },
    single: {
      delete: deleteFloatingip,
      disconnect: disconnectFloatingip,
    },
  },
  "gardener shoot": {
    multiple: {
      delete: deleteMultipleShoots,
      hibernate: hibernateMultipleShoots,
      "retry last operation": retryMultipleShoots,
      "trigger maintenance": maintainMultipleShoots,
      "trigger reconcile": reconcileMultipleShoots,
      "wake up": wakeupMultipleShoots,
    },
    single: {
      delete: deleteShoot,
      hibernate: hibernateShoot,
      "rotate kubeconfig": rotatekubeconfigShoot,
      "trigger maintenance": maintainShoot,
      "trigger reconcile": reconcileShoot,
      "wake up": wakeupShoot,
    },
  },
  "health monitor": {
    single: {
      delete: deleteHealthmonitor,
    },
  },
  "ike policy": {
    multiple: {
      delete: deleteMultipleIkes,
    },
    single: {
      delete: deleteIke,
    },
  },
  image: {
    single: {
      accept: acceptImage,
      delete: deletePrivateImage,
      reject: rejectImage,
    },
  },
  "image member": {
    single: {
      add: addImageMember,
      delete: deleteImageMember,
    },
  },
  "ipsec policy": {
    multiple: {
      delete: deleteMultipleIpsecs,
    },
    single: {
      delete: deleteIpsec,
    },
  },
  "IPSec site connection": {
    single: {
      delete: deleteIpsec_site_connection,
    },
  },
  keypair: {
    multiple: {
      delete: deleteMultipleKeypairs,
    },
    single: {
      delete: deleteKeypair,
    },
  },
  loadbalancer: {
    multiple: {
      delete: deleteMultipleLoadbalancers,
    },
    single: {
      delete: deleteLoadbalancer,
      disconnect: disconnectFloatingip,
    },
  },
  listener: {
    single: {
      delete: deleteListener,
    },
  },
  "magnum cluster": {
    single: {
      delete: deleteCluster,
    },
  },
  network: {
    single: {
      delete: deleteNetwork,
    },
  },
  "openstack user": {
    multiple: {
      delete: deleteMultipleOpenstack_users,
    },
    single: {
      delete: deleteOpenstack_user,
    },
  },
  "orchestration stack": {
    multiple: {
      delete: deleteMultipleOrchestration_stacks,
      resume: resumeMultipleOrchestration_stacks,
      suspend: suspendMultipleOrchestration_stacks,
    },
    single: {
      delete: deleteOrchestration_stack,
      suspend: suspendOrchestration_stack,
    },
  },
  "phone number": {
    single: {
      delete: deletePhone,
    },
  },
  pool: {
    single: {
      delete: deletePool,
    },
  },
  port: {
    multiple: {
      delete: deleteMultiplePorts,
    },
    single: {
      delete: deletePort,
    },
  },
  router: {
    single: {
      delete: deleteRouter,
      "remove interface": removeinterfaceRouter,
    },
  },
  rule: {
    multiple: {
      delete: deleteMultipleRules,
    },
    single: {
      delete: deleteRule,
    },
  },
  schedule: {
    single: {
      delete: deleteSchedule,
    },
  },
  "security group": {
    multiple: {
      delete: deleteMultipleSecurityGroups,
    },
    single: {
      delete: deleteSecuritygroup,
      remove: removeSecurityGroupFromServer,
    },
  },
  server: {
    multiple: {
      delete: deleteMultipleServers,
      pause: pauseMultipleServers,
      reboot: rebootMultipleServers,
      stop: stopMultipleServers,
    },
    single: {
      "cancel resize": resizeCancel,
      delete: deleteServer,
      "disconnect floating ip": disconnectServerFloatingIP,
      pause: pauseServer,
      reboot: rebootServer,
      "restore snapshot": restoresnapshotServer,
      stop: stopServer,
    },
  },
  "server snapshot": {
    multiple: {
      delete: deleteMultipleServer_snapshots,
    },
    single: {
      delete: deleteServer_snapshot,
    },
  },
  subnet: {
    single: {
      delete: deleteSubnet,
    },
  },
  "stack snapshot": {
    single: {
      delete: deleteStack_snapshot,
      restore: restoreStack_snapshot,
    },
  },
  volume: {
    multiple: {
      delete: deleteMultipleVolumes,
      detach: detachMultipleVolumes,
      "disable disaster recovery": disableDisasterRecoveryMultipleVolumes,
      "enable disaster recovery": enableDisasterRecoveryMultipleVolumes,
    },
    single: {
      delete: deleteVolume,
      detach: detachVolume,
      "disable disaster recovery": disableDisasterRecoveryVolume,
      "enable disaster recovery": enableDisasterRecoveryVolume,
      "restore snapshot": restoresnapshotVolume,
    },
  },
  "volume snapshot": {
    multiple: {
      delete: deleteMultipleVolume_snapshots,
    },
    single: {
      delete: deleteVolume_snapshot,
    },
  },
  "VPN service": {
    multiple: {
      delete: deleteMultipleVpns,
      reset: resetMultipleVPNs,
    },
    single: {
      delete: deleteVpn,
    },
  },
  "worker group": {
    single: {
      delete: deleteWorker,
    },
  },
  "Provisioned App": {
    single: {
      delete: deleteProvisionedApp,
    },
    multiple: {
      delete: deleteMultipleProvisionedApps,
    },
  },
};
